import { faFile } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FunctionComponent } from 'react';
import styles from './ClientOverviewInvoicesEmpty.module.scss';

export const ClientOverviewInvoicesEmpty: FunctionComponent = () => (
    <div className={styles.emptyState}>
        <div className={styles.iconCircle}>
            <FontAwesomeIcon
                icon={faFile}
                className={styles.icon}
            />
        </div>
        <p className={styles.emptyTitle}>No Invoices Yet</p>
        <p className={styles.emptyDescription}>This client has no registered invoices.</p>
    </div>
);

export default ClientOverviewInvoicesEmpty;
